import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservicepune() {



  const cardData = {
"keyword": "Corporate Cab Service Pune",

"headingDescription":
  "Shivai Travels offers reliable and professional Corporate Cab Service in Pune designed to meet the transportation needs of businesses, IT companies, startups, and corporate organizations. We provide safe, punctual, and comfortable travel solutions for employee transportation, daily office pick-ups and drops, airport transfers, client visits, business meetings, and corporate events. With experienced chauffeurs, well-maintained vehicles, GPS-enabled tracking, and transparent billing, we ensure seamless travel management for companies of all sizes. Our fleet includes air-conditioned sedans, SUVs, and premium vehicles, along with flexible monthly, daily, and contract-based corporate travel plans. Shivai Travels ensures 24/7 support, timely service, and cost-effective mobility solutions for corporate clients in Pune and nearby areas.",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description":
      "Hinjewadi IT Park is one of Pune’s largest corporate hubs, hosting major IT companies and tech offices. Corporate Cab Service in Pune ensures smooth daily employee transportation to and from this busy business district."
  },
  {
    "title": "Magarpatta City",
    "description":
      "Magarpatta City is a well-developed IT and business township in Pune with offices, residential zones, and commercial spaces. Corporate cab services are widely used here for employee commute and business travel."
  },
  {
    "title": "Kharadi EON IT Park",
    "description":
      "Kharadi EON IT Park is a major corporate hub in Pune with multinational companies and IT firms. Reliable corporate cab services ensure punctual and comfortable travel for employees working in this area."
  },
  {
    "title": "Baner Business District",
    "description":
      "Baner is a fast-growing commercial area in Pune with offices, startups, and business centers. Corporate cab services are commonly used for daily commuting and client meetings in this region."
  },
  {
    "title": "Viman Nagar",
    "description":
      "Viman Nagar is a prime business and residential locality near Pune Airport, hosting offices and corporate spaces. Corporate cab service in Pune ensures easy airport transfers and business travel from this area."
  },
  {
    "title": "Wakad IT Corridor",
    "description":
      "Wakad is a rapidly developing IT and residential zone near Hinjewadi. Corporate cab services provide efficient transport solutions for employees traveling to IT parks and offices here."
  },
  {
    "title": "Pune Airport (Lohegaon)",
    "description":
      "Pune Airport is a key transit point for corporate travelers and business executives. Corporate cab service ensures timely airport pickups and drop-offs for smooth business travel."
  },
  {
    "title": "Shivajinagar Business Area",
    "description":
      "Shivajinagar is a central business district in Pune with government offices and commercial establishments. Corporate cabs are commonly used here for official meetings and professional travel."
  },
  {
    "title": "Hadapsar Industrial Area",
    "description":
      "Hadapsar is a major industrial and IT zone in Pune with numerous corporate offices and manufacturing units. Corporate cab services support daily employee transportation and business logistics."
  },
  {
    "title": "Bund Garden Corporate Zone",
    "description":
      "Bund Garden area hosts several corporate offices, hotels, and business centers. Corporate cab services provide reliable travel solutions for meetings, conferences, and office commutes."
  }
],



services: [
  {
    name: "Corporate Cab Service Pune",
    description: "Corporate cab service Pune provides professional transportation solutions for business travelers, company employees, and corporate events across Pune. Comfortable vehicles with experienced chauffeurs ensure punctual pickup and safe travel for office commutes, airport transfers, and client meetings. Pickup services are available from offices, homes, hotels, railway stations, and airport terminals. Vehicles include sedans, SUVs, Innova Crysta, and premium corporate cars suitable for executive travel requirements. Flexible booking options allow convenient daily, monthly, and long-term corporate transportation planning."
  },
  {
    name: "Business Cab Service Pune",
    description: "Business cab service Pune offers reliable transportation for corporate professionals, executives, and business travelers within Pune and nearby destinations. Comfortable vehicles provide smooth city and highway travel suitable for meetings, conferences, and airport transfers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from offices, hotels, homes, railway stations, and airport terminals across Pune. Flexible booking options allow convenient business travel reservations."
  },
  {
    name: "Employee Transport Pune",
    description: "Employee transport Pune service provides dependable transportation for office staff and company employees traveling across Pune. Comfortable vehicles ensure smooth daily commute experience with professional drivers maintaining punctual pickup and drop schedules. Pickup services are available from residential areas, corporate offices, IT parks, and business centers across Pune. Ideal for employee shift transportation, office commutes, and staff travel requirements. Flexible booking options allow convenient employee transportation planning."
  },
  {
    name: "Office Cab Service Pune",
    description: "Office cab service Pune offers professional transportation solutions for employees, executives, and corporate teams traveling to offices and business locations. Vehicles provide comfortable seating and smooth travel experience suitable for daily office commute and airport transfers. Professional chauffeurs ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient office cab scheduling."
  },
  {
    name: "Corporate Taxi Pune",
    description: "Corporate taxi Pune service provides reliable transportation for business meetings, executive travel, airport transfers, and corporate events. Comfortable vehicles ensure professional and smooth travel experience for company employees and clients. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from offices, homes, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient corporate taxi reservations."
  },
  {
    name: "Company Cab Service Pune",
    description: "Company cab service Pune provides organized transportation solutions for businesses, employees, and corporate teams across Pune. Comfortable vehicles ensure smooth daily office commute and professional travel experience for staff members. Professional chauffeurs maintain punctual pickup schedules and safe driving services throughout the journey. Pickup services are available from residential areas, offices, hotels, railway stations, and airports. Flexible booking options allow convenient company transportation management."
  },
  {
    name: "Staff Transportation Pune",
    description: "Staff transportation Pune service offers dependable employee travel solutions for offices, IT companies, factories, and corporate organizations. Comfortable vehicles provide smooth city travel experience suitable for daily staff commute and shift-based transportation. Professional drivers ensure safe driving and timely pickup-drop services across Pune. Pickup services are available from residential areas, offices, business parks, and industrial locations. Flexible booking options allow convenient staff transportation scheduling."
  },
  {
    name: "Corporate Cab Booking Pune",
    description: "Corporate cab booking Pune service allows businesses and professionals to reserve comfortable transportation for office travel, airport transfers, and executive journeys. Vehicles include sedans, SUVs, premium cars, and Innova Crysta suitable for corporate travel requirements. Professional chauffeurs ensure punctual pickup and safe transportation services for passengers. Pickup services are available from offices, homes, hotels, railway stations, and airports across Pune. Flexible booking options allow instant and advance corporate cab reservations."
  },
  {
    name: "Executive Cab Service Pune",
    description: "Executive cab service Pune provides premium transportation for corporate executives, business leaders, and VIP travelers. Luxury vehicles offer spacious interiors, smooth ride quality, and comfortable travel suitable for meetings, airport transfers, and official events. Professional chauffeurs ensure safe driving and punctual pickup services across Pune. Pickup services are available from offices, hotels, homes, railway stations, and airport terminals. Flexible booking options allow convenient executive cab reservations."
  },
  {
    name: "Corporate Travel Cab Pune",
    description: "Corporate travel cab Pune service offers reliable transportation for official travel, business meetings, conferences, and company events. Comfortable vehicles ensure smooth city and highway travel with professional chauffeurs maintaining punctuality and professionalism. Pickup services are available from offices, homes, hotels, railway stations, and airport terminals across Pune. Ideal for corporate teams, executives, and business guests. Flexible booking options allow convenient corporate travel planning."
  },
  {
    name: "Monthly Cab Service Pune",
    description: "Monthly cab service Pune provides long-term transportation solutions for office employees, corporate travelers, and regular commuters. Comfortable vehicles ensure smooth and reliable daily travel experience with professional drivers offering punctual pickup and drop services. Pickup services are available across Pune including residential areas, offices, IT parks, and industrial zones. Ideal for employee transportation and regular office travel requirements. Flexible booking options allow convenient monthly cab scheduling."
  },
  {
    name: "Employee Pickup Drop Pune",
    description: "Employee pickup drop Pune service offers dependable transportation for office staff and company employees traveling across Pune city. Comfortable vehicles ensure smooth daily commute with professional chauffeurs maintaining safe driving and timely schedules. Pickup services are available from residential areas, offices, IT parks, and business hubs across Pune. Ideal for regular office commute and shift-based employee transportation. Flexible booking options allow convenient employee pickup and drop arrangements."
  },
  {
    name: "Corporate Fleet Pune",
    description: "Corporate fleet Pune service provides organized transportation solutions with multiple vehicles for businesses, companies, and corporate organizations. Vehicles include sedans, SUVs, premium cars, and executive taxis suitable for employee travel and official transportation needs. Professional chauffeurs ensure safe driving and punctual transportation services across Pune. Pickup services are available from offices, hotels, homes, railway stations, and airports. Flexible booking options allow convenient corporate fleet management."
  },
  {
    name: "Premium Corporate Cab Pune",
    description: "Premium corporate cab Pune service provides luxury transportation for executives, corporate guests, and business professionals traveling within Pune and nearby destinations. Premium vehicles offer spacious seating, smooth ride quality, and advanced travel comfort suitable for official meetings and airport transfers. Professional chauffeurs ensure safe driving and punctual pickup services. Pickup services are available from offices, homes, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium corporate cab reservations."
  },
  {
    name: "Office Commute Cab Pune",
    description: "Office commute cab Pune service provides reliable transportation for employees and professionals traveling daily between home and office locations. Comfortable vehicles ensure smooth city travel with experienced drivers maintaining punctual pickup and drop schedules. Pickup services are available from residential areas, offices, IT parks, and business centers across Pune. Ideal for daily office commute, employee transportation, and corporate travel requirements. Flexible booking options allow convenient office commute cab scheduling."
  },
  {
    name: "Best Corporate Cab Service in Pune",
    description: "Best corporate cab service in Pune offers professional transportation solutions for businesses, executives, and office employees with comfortable vehicles and experienced chauffeurs. Vehicles provide smooth city and airport travel suitable for meetings, conferences, and corporate events. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from offices, hotels, homes, railway stations, and airport terminals. Flexible booking options allow convenient and reliable corporate transportation planning."
  }
],

tableData: [
  ["Corporate Cab Service Pune", "Business Cab Service Pune"],
  ["Employee Transport Pune", "Office Cab Service Pune"],
  ["Corporate Taxi Pune", "Company Cab Service Pune"],
  ["Staff Transportation Pune", "Corporate Cab Booking Pune"],
  ["Executive Cab Service Pune", "Corporate Travel Cab Pune"],
  ["Monthly Cab Service Pune", "Employee Pickup Drop Pune"],
  ["Corporate Fleet Pune", "Premium Corporate Cab Pune"],
  ["Office Commute Cab Pune", "Best Corporate Cab Service in Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Professional Corporate Cab Service",
        WhyChoosedescription: "Shivai Travels provides professional corporate cab service in Pune for office staff transportation, business meetings, airport transfers, and corporate events with punctual and reliable travel solutions."
      },
      {
        WhyChooseheading: "Affordable Corporate Travel Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable and transparent pricing for corporate cab service Pune with customized packages for daily employee transport, executive travel, and business trips."
      },
      {
        WhyChooseheading: "24/7 Corporate Transportation Availability",
        WhyChoosedescription: "Our corporate cab service in Pune operates 24 hours a day for airport pickups, late-night employee drops, business meetings, and emergency corporate travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Premium AC Vehicles",
        WhyChoosedescription: "All vehicles provided by Shivai Travels are fully air-conditioned, clean, sanitized, and well maintained to provide comfortable corporate travel experiences for employees and executives."
      },
      {
        WhyChooseheading: "Flexible Corporate Travel Solutions",
        WhyChoosedescription: "Shivai Travels provides flexible transportation solutions including employee pickup and drop, airport transfer services, outstation business trips, event transportation, and customized corporate travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Corporate Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for executives, teams, business delegates, and corporate groups."
      },
      {
        WhyChooseheading: "Corporate Pickup Across Pune IT Hubs",
        WhyChoosedescription: "Shivai Travels provides corporate pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Magarpatta, Kharadi, Hadapsar, Pimpri Chinchwad, and Viman Nagar."
      },
      {
        WhyChooseheading: "Reliable Corporate Cab Service in Pune",
        WhyChoosedescription: "Shivai Travels is trusted by corporate clients for punctual transportation, professional drivers, clean vehicles, and smooth travel experiences for employees and business travelers."
      }
    ]
  };

  const faqData = [
    { question: "What is corporate cab service Pune?", answer: "Corporate cab service Pune provides transportation solutions for office employees, executives, airport transfers, and business travel requirements." },
    { question: "Is corporate cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 corporate cab service in Pune." },
    { question: "Which vehicles are available for corporate travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers for corporate transportation." },
    { question: "Do you provide employee pickup and drop service?", answer: "Yes, Shivai Travels provides employee transportation and office pickup-drop services across Pune." },
    { question: "Do you provide airport transfers for corporate clients?", answer: "Yes, Shivai Travels provides Pune airport transfer services for corporate executives and business travelers." },
    { question: "Are all corporate taxis air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned, clean, and maintained for comfortable corporate travel." },
    { question: "Can companies book monthly cab services?", answer: "Yes, Shivai Travels offers customized monthly and long-term corporate cab packages." },
    { question: "Do you provide outstation corporate travel services?", answer: "Yes, Shivai Travels provides outstation taxi services for business meetings and corporate tours." },
    { question: "Are corporate cab fares affordable?", answer: "Yes, Shivai Travels offers affordable and transparent pricing for corporate transportation services." },
    { question: "Is advance corporate booking available?", answer: "Yes, advance booking is available for corporate travel, employee transportation, and event transportation services." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Joshi",
    feedback:
      "Shivai Travels provided excellent corporate cab service in Pune with punctual pickups, professional drivers, and a well-maintained vehicle suitable for business travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The corporate taxi service in Pune was very reliable for our office travel needs, offering smooth coordination, clean cars, and consistent on-time service.",
    rating: 5
  }
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service Pune",
  "image": "https://shivaitravels.com/assets/images/corporate-cab-service-pune.jpg",
  "description": "Book reliable corporate cab service in Pune for employee transportation, office pickup and drop, business travel, and executive cab services. Shivai Travels provides professional, safe, and affordable corporate taxi solutions with monthly packages and premium fleet options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/corporate-cab-service-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Service Pune | Employee Transportation & Business Travel | +91 9689815477</title>

  <meta
    name="description"
    content="Book corporate cab service in Pune for employee transportation, office pickup & drop, executive travel, and business cab solutions. Affordable and reliable corporate taxi service available 24x7."
  />

  <meta
    name="keywords"
    content="Corporate cab service pune, business cab service pune, employee transport pune, office cab service pune, corporate taxi pune, company cab service pune, staff transportation pune, corporate cab booking pune, executive cab service pune, corporate travel cab pune, monthly cab service pune, employee pickup drop pune, corporate fleet pune, premium corporate cab pune, office commute cab pune, Corporate Cab Service Pune, Corporate Cab Services in Pune, Corporate Taxi Service Pune, Employee Transportation Service Pune, Corporate Car Rental Pune, Office Cab Service Pune, Business Cab Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabservicepune;